import { isEmailField, isDecimalField, isWholeBuildingSquareFootageField, isSuiteSquareFeetField, isParcelSizeField, isZipCodeField } from './validation';

const requiredField = (path, RefName, message) => ({
  path,
  RefName,
  pattern: /\S+/,
  message,
  emptyCheck: true,
});

const validationSchema = [
  isEmailField('tenantPOCEmail.value', 'tenantPOCEmail'),
  isEmailField('landlordPOCEmail.value', 'landlordPOCEmail'),
  isParcelSizeField('parcelSize.value', 'parcelSize'),
  isDecimalField('baseRent.value', 'baseRent'),
  isDecimalField(
    'tenantImprovementAllowance.value',
    'tenantImprovementAllowance',
  ),
  isDecimalField('parkingRatio.value', 'parkingRatio'),
  isWholeBuildingSquareFootageField('squareFeet.value', 'squareFeet'),
  isSuiteSquareFeetField('squareFeet.value', 'squareFeet'),
  isZipCodeField('zip.value', 'zip'),
];

// Additional required-field rules used only by the Comp Data abstraction tab
export const compValidationSchema = [
  ...validationSchema,
  requiredField('tenantRepresentCompany.value', 'tenantRepresentCompany', 'Tenant Represented By is required'),
  requiredField('tenantRepresentAgent.value', 'tenantRepresentAgent', 'Tenant Represented By Agent is required'),
  requiredField('landlordRepresentCompany.value', 'landlordRepresentCompany', 'Landlord Represented By is required'),
  requiredField('landlordRepresentAgent.value', 'landlordRepresentAgent', 'Landlord Represented By Agent is required'),
  requiredField('baseRent.value', 'baseRent', 'Base Rent ($/SF per year) is required'),
  requiredField('freeRent.value', 'freeRent', 'Free Rent is required'),
  requiredField('leaseEscalation.value', 'leaseEscalation', 'Lease Escalation is required'),
  requiredField('tenantImprovementAllowance.value', 'tenantImprovementAllowance', 'Tenant Improvement Allowance ($/SF) is required'),
  requiredField('tenantImprovementDetails.value', 'tenantImprovementDetails', 'Tenant Improvements Detail is required'),
];

export default validationSchema;
